import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CareerRecordColumns } from '../components/sections/CareerRecordColumns';
export function CareerTrackRecordPage() {
  return <div data-id="element-215" data-mp="nee94h720ptz">
      <PageHeader eyebrow="Executive Career Track Record" title="Milestones, Awards & Industry Speaking Engagements" data-id="element-216" data-mp="nduzdnrk57r1" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-217" data-mp="s7qsabsys4fc">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-218" data-mp="x5ij12hvhkhy">
          <CareerRecordColumns data-id="element-219" data-mp="x73ceosgaxe8" />
        </div>
      </section>
    </div>;
}